import { useHistory } from "react-router-dom";

import classes from "./Blank.module.scss";

import poly from '../../assets/images/poly_icon.svg'
import logo from '../../assets/images/synergy_logo.svg';
import badgeLogo from '../../assets/images/badge.svg';
import synergyLogo from '../../assets/images/Logosynergy.svg'

export interface SplashProps {
}

export const Blank = () => {

  return (
    <div className={classes.totalwrap}>
      <span></span>
    </div>
  )
}
